import { Box, Typography } from '@mui/material';

import { FORTA_BLACK } from '../../../../utils/colors';

const ParentSNSignatureMessage = () => (
  <Box>
    <Typography variant="body1" align="left" color={FORTA_BLACK} fontSize={12}>
      By signing and submitting these notes, plan and/or records (each a “record”), I hereby attest
      that (i) the entry for the date of service listed in the record accurately and completely
      reflects the services rendered by the named clinician herein; (ii) I have thoroughly reviewed
      the records; and (iii) I have discussed all applicable findings, outcomes, issues or
      discrepancies with the client and/or client&apos;s legal guardian, as appropriate.
    </Typography>
    <br />
    <Typography variant="body1" align="left" color={FORTA_BLACK} fontSize={12}>
      I understand that any falsification, omission, or concealment of facts may subject me to
      administrative, civil, or criminal liability as well as termination of my employment with the
      company.
    </Typography>
  </Box>
);

export default ParentSNSignatureMessage;
